// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"318d184f856bcf5370e6","532":"9a596efb58ece2eccd3a","691":"a939eb1d578eb3a498b1"}[chunkId] + ".js";
};